module.exports = __webpack_public_path__ + "static/media/img24.4eadd163.JPG";